import { mapValues, uniq } from 'es-toolkit';
import { createSelector } from '@reduxjs/toolkit';

import { getProductionComponentInstancesByProductionGroupGuid } from './getProductionComponentInstancesByProductionGroupGuid';

export const getAnalysisSetGuidsByProductionGroupGuid = createSelector(
  getProductionComponentInstancesByProductionGroupGuid,

  (productionComponentInstancesByProductionGroupGuid) => {
    const analysisSetGuidsByProductionGroup = mapValues(
      productionComponentInstancesByProductionGroupGuid,
      (productionComponentInstancesInProductionGroup) =>
        uniq(productionComponentInstancesInProductionGroup.map((instance) => instance.analysisSetGuid)),
    );
    return analysisSetGuidsByProductionGroup;
  },
);
